


















































import { Vue, Component } from "vue-property-decorator";
import { getCurrentCompanyId, getCurrentUserId } from "@/plugins/roles";
import { uniqBy } from "lodash";
import { NotificationsListParams, list } from "@/getinfo-api/notifications";
import { Notification as INotification } from "@/api-v2/notification/models/notification";
import { notificationApi } from "@/getinfo-api";

@Component
export default class NotificationDropdown extends Vue {
  notifications: INotification[] = [];
  count: number = 0;
  intervalId!: number;
  isLoading: boolean = false;
  uniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  data() {
    return {
      intervalId: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get userId() {
    return getCurrentUserId();
  }

  async markedAllAsRead() {
    await Promise.allSettled(
      this.notifications?.map(async el => {
        await this.markedAsRead(el.id!);
      })
    );
  }

  async markedAsRead(notificationId: string) {
    try {
      this.isLoading = true;

      await notificationApi.Notification.readNotification(notificationId);

      this.notifications = this.notifications?.filter(
        el => el.id !== notificationId
      );
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async getNotifications() {
    const params: NotificationsListParams = {
      userId: this.userId,
      companyId: this.companyId ?? undefined,
      sort: "createdAt",
      order: "DESC",
      read: false,
      limit: 100
    };

    const { data } = await list(params);
    this.count = data.count;
    this.notifications = uniqBy([...this.notifications, ...data.items], "id");
  }

  init() {
    this.intervalId = window.setInterval(this.getNotifications, 60000);
  }

  created() {
    this.getNotifications();
    this.init();
  }

  beforeDestroy() {
    window.clearInterval(this.intervalId);
  }
}
